import React, { useEffect, useState, useRef } from 'react';
import { makeAjax, showMessage, url, respStatus, dotNumberValidation, dotNumberBlurValidation, withDotValidation } from '../../../../../../helpers/global_helper';
import BetSuccessPopup from '../../../../../Popups/BetSuccessPopup';
import ConfirmBetDeskonPopup from '../../../../../Popups/ConfirmBetDeskonPopup';
import { useDispatch, useSelector } from 'react-redux';
import ErrorPopup from '../../../../../Popups/ErrorPopup';
import ErrorInnerPopup from '../../../../../Popups/ErrorInnerPopup';
import ConfirmDataBetDeskonPopup from '../../../../../Popups/ConfirmDataBetDeskonPopup';
import { FaBullseye } from 'react-icons/fa';
import CancelledBetDeskonPopup from '../../../../../Popups/CancelledBetDeskonPopup';
import { withTranslation } from "react-i18next";
import { formatPrice } from '../../../../../NumberFormat';
import TableCount from '../../FourDThreeDTwoD/TableCount';
import { getUserBalance, setCommonConfig } from '../../../../../../redux/actions';
import { mobileTotalBetCalculate } from "../../FourDThreeDTwoD/MobileTotalBetCalcy";
import GameClosedPopup from '../../../GameClosedPopup';
import MarketClose from '../../../MarketClose';
import CommonBetHeader from '../../../CommonBetHeader';

const Bet_Diskon = (props) => {
    const totaldiv = useRef();
    const dispatch = useDispatch();
    const device = useSelector(state => state.CommonConfig.device_type);
    const gameId = useSelector((state) => state.CommonConfig.gameId);
    const betDiscount = useSelector((state) => state.CommonConfig.discount);
    const user_balance = useSelector(state => state.UserBalance.user_balance);
    const [dicountValue, setDiscountValue] = useState()
    const [maxAmountValue, setMaxtAmountValue] = useState()
    const [minAmountValue, setMinAmountValue] = useState()
    const [rowsToShow, setRowsToShow] = useState(10);
    const [successPopup, setSuccessPopup] = useState(false)
    const [showConfirmationPopup, setShowConfirmationPopup] = useState(false);
    const [showCancelledPopup, setShowCancelledPopup] = useState(false);
    const [showConfirmationDataPopup, setShowConfirmationDataPopup] = useState(false);
    const [inputToShow, setInputToShow] = useState(4);
    const [respData, setRespData] = useState([]);
    const [values, setValues] = useState([]);
    const [angaka, setAngaka] = useState([]);
    const [angakaBB, setAngakaBB] = useState([]);
    const [rowInd, setRowInd] = useState(0);
    const initialReq4D = {
        isfullbet: null,
        gameId: null,
        gameType: "2dposisitengah",
        dfp: "diskon",
        action: "process",
        betTogelAuth: "betTogelAuth",
        allowPartner: "allowPartner",
        dataangka: []
    }
    const initialReqBB = {
        gameId: null,
        gameType: "bolak-balik",
        dfp: "diskon",
        action: "process",
        betTogelAuth: "betTogelAuth",
        allowPartner: "allowPartner",
        dataangka: []
    }
    const initialReqBB4D = {
        gameId: null,
        gameType: "4d3d2d",
        dfp: "diskon",
        action: "process",
        betTogelAuth: "betTogelAuth",
        allowPartner: "allowPartner",
        dataangka: []
    }
    const [newAngakaD, setNewAngakaD] = useState([])
    const [reqData, setReqData] = useState(initialReq4D);
    const [newReqData, setNewReqData] = useState(initialReqBB);
    const [reqBBData, setReqBBData] = useState(initialReqBB4D);
    const [changeReqData, setChangesReqData] = useState(initialReq4D)
    const [showMarketClose, setShowMarketClose] = useState(false);
    const [showGameClose, setShowGameClose] = useState(false);

    const colRef = useRef({});
    const [bets, setBets] = useState({});
    const [belliBets, setBelliBets] = useState({});
    const [diskon, setDiskon] = useState({});
    const [bolakBalik, setBolakBalik] = useState({});
    const [belli, setBbelli] = useState({});
    const [probabilityTable, setProbabilityTable] = useState(false)
    const [mainButton, setMainButton] = useState(true)
    const [showErrorPopup, setShowErrorPopup] = useState(false)
    const [errMessage, setErrorMessage] = useState('');
    const [succMessage, setSuccessMessage] = useState('');
    const [bolBalikRow, setBolBalikRow] = useState([]);
    const [bolBalikRowALL, setBolBalikRowAll] = useState(0);
    const [bolakBalikRespArray, setBolakBalikRespArray] = useState([])
    const [checkedBoxes, setCheckedBoxes] = useState(Array(bolakBalikRespArray.length).fill(true));
    const [totalAmount, setTotalAmount] = useState(0)
    const [totalBetAmount, setTotalBetAmount] = useState([]);
    const [bbPayAmount, setBBPayAmount] = useState(0);
    const [payAmount, setPayAmount] = useState(0);
    const [discountAmount, setDiscountAmount] = useState(0);
    const [payAmountStatus, setPayAmountStatus] = useState(false)
    const [mobMaxValidate, setMobMaxValidate] = useState(0)
    const [bolakBalikRespAngka, setBolakBalikRespAngka] = useState([])
    const [defaultValue, setDefaultvalue] = useState("")
    const [beliDisabled, setBeliDisabled] = useState(Array(rowsToShow).fill(true));
    const game_sub_child_type = useSelector((state) => state.GameSubType.game_sub_child_type);
    const [multipleValue, setMultipleValue] = useState('');

    useEffect(() => {
        let multiple = '';
        if (game_sub_child_type === 'DISCOUNT') {
            multiple = betDiscount.showMultiple;
        } else if (game_sub_child_type === 'FULLBET') {
            multiple = betDiscount.showMultipleFullbet;
        } else {
            multiple = betDiscount.showMultiple;
        }
        setMultipleValue(multiple);
    }, [game_sub_child_type]);

    // Mobie Usestate ============
    const [mobbets, setMobBets] = useState({})
    const handleInputFocus = (e, rowIndex, inputInd, columnName) => {
        setRowInd(rowIndex)
        const { name, value } = e.target;
        let updatedBets = { ...bets };
        if (inputInd > 0 & value !== '') {
            for (let j = 0; j < inputInd; j++) {
                const prevInputName = `bets${rowIndex}${j}`;
                if (!updatedBets[prevInputName]) {
                    updatedBets[prevInputName] = '';
                }
            }
            updatedBets[name] = value;
            setBets(updatedBets);
        }
        else if (inputInd == 3 && value == '' && updatedBets[`bets${rowIndex}0`] != '' && updatedBets[`bets${rowIndex}1`] != '') {
            setBets({
                ...bets,
                [name]: value
            });
        }
        else if (inputInd == 2 && value == '' && updatedBets[`bets${rowIndex}0`] != '' && updatedBets[`bets${rowIndex}1`] != '') {
            setBets({
                ...bets,
                [name]: value
            });
        }
        else {
            setBets({
                ...bets,
                [name]: value
            });
        }
    }

    const handleInputChange = (e, rowIndex, inputInd, columnName) => {
        setRowInd(rowIndex)
        const { name, value } = e.target;
        const onlyNumbers = value.replace(/[^0-9]/g, '') ? value.replace(/[^0-9]/g, '') : '';
        const onlyNumbersMob = value.replace(/[^0-9]/g, '') ? value.replace(/[^0-9]/g, '') : '';

        if (device === "Desktop") {
            let updatedBets = { ...bets };
            updatedBets[name] = onlyNumbers;
            if (inputInd > 0) {
                for (let j = 0; j < inputInd; j++) {
                    const prevInputName = `bets${rowIndex}${j}`;
                    if (!updatedBets[prevInputName]) {
                        updatedBets[prevInputName] = '';
                    }
                }
            }
            setBets(updatedBets);
            validateBeliInput(rowIndex, updatedBets);

            const inputIndex = `${rowIndex}${inputInd + 1}`;
            if (onlyNumbers !== 'X' && onlyNumbers !== '') {
                colRef.current[inputIndex].focus();
            }

        } else {
            setMobMaxValidate(0)
            const newMobBets = {
                ...mobbets,
                [name]: onlyNumbersMob
            };
            setMobBets(newMobBets);

            const enableBelli = onlyNumbersMob.length === 2;
            const beliInput = document.querySelector(`input[name="${rowIndex}"][placeholder="1 = 1,000 IDR"]`);
            if (beliInput) {
                beliInput.disabled = !enableBelli;
            }
            const newdisabledVal = beliDisabled.map((item, ind) => {
                if (ind == rowIndex && item === true && onlyNumbersMob.length === 2) {
                    return !item
                }
                else {
                    if (onlyNumbersMob.length < 2 && ind == rowIndex && item == false) {
                        return !item
                    }
                    else {
                        return item
                    }
                }
            })
            setBeliDisabled(newdisabledVal);
            if (onlyNumbersMob.length === 2) {
                const newIndex = `${rowIndex}-belli`
                setTimeout(() => {
                    colRef.current[newIndex].focus();
                }, 0)
            }
        }
    };

    const updateBetNumber = () => {
        if (device === "Desktop") {
            let newValue = [...values];
            let betVal = '';
            let allBetsFilled = true;
            // Check if all bet values for the current row are not empty and defined
            for (let k = 1; k < 3; k++) {
                if (typeof bets['bets' + rowInd + '' + k] === undefined || bets['bets' + rowInd + '' + k] === '') {
                    allBetsFilled = false;
                    break;
                }
            }
            if (device === "Desktop") {
                for (let k = 1; k < 3; k++) {
                    betVal += bets['bets' + rowInd + '' + k];
                }
                let splitVal = betVal.split('');
                let conditionMet = false;
                if (
                    (splitVal[1] === "X" && splitVal[2] === "X") ||
                    (splitVal[1] === "" && splitVal[2] === "")) {
                    conditionMet = true;
                }

                if (conditionMet) {
                    newValue[rowInd] = undefined; // Remove the value at the specified rowInd
                } else {
                    newValue[rowInd] = "X" + betVal + "X"; // Update the value at the specified rowInd
                }
                setValues(newValue);
            } else {
                if (allBetsFilled) {
                    for (let k = 1; k < 3; k++) {
                        betVal += bets['bets' + rowInd + '' + k];
                    }
                    let splitVal = betVal.split('');
                    let conditionMet = false;
                    if (
                        (splitVal[1] === "X" && splitVal[2] === "X") ||
                        (splitVal[1] === "" && splitVal[2] === "")) {
                        conditionMet = true;
                    }

                    if (conditionMet) {
                        newValue[rowInd] = undefined; // Remove the value at the specified rowInd
                    } else {
                        newValue[rowInd] = "X" + betVal + "X"; // Update the value at the specified rowInd
                    }
                    setValues(newValue);
                }
            }
        }
    };

    useEffect(() => {
        updateBetNumber()
    }, [bets, rowInd])

    useEffect(() => {
        let newValue = [...values]
        if (typeof mobbets['mobbets' + rowInd] != 'undefined') {
            if (mobbets['mobbets' + rowInd] != '' && mobbets['mobbets' + rowInd].length === 2) {
                newValue[rowInd] = mobbets['mobbets' + rowInd]
            }
            else {
                if (mobbets['mobbets' + rowInd]) {
                    newValue[rowInd] = undefined;
                }
            }
        }
        setValues(newValue);
    }, [mobbets, belli])

    const handleFocusInput = (e, rowIndex) => {
        setRowInd(rowIndex)
        const { name, value } = e.target
        if (value === '' && defaultValue) {
            setBelliBets((prevBets) => ({
                ...prevBets,
                [rowIndex]: defaultValue,
            }));
        }
        setMobMaxValidate(1)
    };

    useEffect(() => {
        let maxAmount;
        let minAmount;
        let discountVal = ''
        if (mobbets['mobbets' + rowInd] !== undefined) {
            if (mobbets['mobbets' + rowInd].length == 2) {
                maxAmount = betDiscount.showMax2dTengah
                minAmount = betDiscount.showMin2dTengah
                discountVal = betDiscount.showDisc2d
            }
            else {
                //
            }
            let newMaxAmount;
            if (betDiscount.userBetLimitPerc) {
                newMaxAmount = maxAmount * (betDiscount.userBetLimitPerc.tg_limit_percent) / 100
            }
            setMaxtAmountValue(newMaxAmount)
            setMinAmountValue(minAmount)
            setDiscountValue(discountVal)
        }
    }, [mobbets, belliBets])

    useEffect(() => {
        const isValidate = (belliAmount) => {
            return belliAmount !== '' && belliAmount !== undefined && !isNaN(belliAmount)
        }
        if (isValidate(defaultValue) || isValidate(belliBets[rowInd])) {
            let maxAmount = ''
            let minAmount = ''
            if (device === "Desktop") {
                maxAmount = betDiscount.showMax2dTengah
                minAmount = betDiscount.showMin2dTengah
                let newMaxAmount;
                if (betDiscount.userBetLimitPerc) {
                    newMaxAmount = maxAmount * (betDiscount.userBetLimitPerc.tg_limit_percent) / 100
                }
                if ((belliBets[rowInd] * betDiscount.showMultiple) > newMaxAmount) {
                    setBelliBets({
                        ...belliBets,
                        [rowInd]: '',
                    });
                    setBbelli((prevBelli) => ({
                        ...prevBelli,
                        [rowInd]: '',
                    }));
                    setBolakBalik({
                        ...bolakBalik,
                        [rowInd]: '',
                    });
                    setDiskon({
                        ...diskon,
                        [rowInd]: '',
                    });
                    setErrorMessage(props.t('you_have_reached_max_bet_value'));
                    setShowErrorPopup(true);
                }
            }
            else {
                if (mobbets['mobbets' + rowInd] !== undefined && mobMaxValidate > 0 && maxAmountValue > 0) {
                    if ((belliBets[rowInd] * betDiscount.showMultiple) > betDiscount.showMax2dTengah) {
                        setBelliBets({
                            ...belliBets,
                            [rowInd]: '',
                        });
                        setBbelli((prevBelli) => ({
                            ...prevBelli,
                            [rowInd]: '',
                        }));
                        setBolakBalik({
                            ...bolakBalik,
                            [rowInd]: '',
                        });
                        setDiskon({
                            ...diskon,
                            [rowInd]: '',
                        });
                        setErrorMessage(props.t('you_have_reached_max_bet_value'));
                        setShowErrorPopup(true);
                        // }
                        // else if (belliBets[rowInd] == 0 && belliBets[rowInd] !== undefined && belliBets[rowInd] !== '') {
                        //     setBelliBets({
                        //         ...belliBets,
                        //         [rowInd]: "",
                        //     });
                        //     setBbelli((prevBelli) => ({
                        //         ...prevBelli,
                        //         [rowInd]: "",
                        //     }));
                        //     setBolakBalik({
                        //         ...bolakBalik,
                        //         [rowInd]: "",
                        //     });
                        // localStorage.getItem("I18N_LANGUAGE") == "en"
                        //     ? setErrorMessage(
                        //         `Minimal bet ${mobbets["mobbets" + rowInd].length + "D"} is 1`
                        //     )
                        //     : setErrorMessage(
                        //         `Minimal taruhan ${mobbets["mobbets" + rowInd].length + "D"
                        //         } adalah 1`
                        //     );
                        // setShowErrorPopup(true);
                    }
                    else {
                        let value = belliBets[rowInd] ? belliBets[rowInd] : parseInt(defaultValue)
                        const newDiskon = value * betDiscount.showMultiple * (dicountValue) / 100;
                        const newBolakBalik = value * betDiscount.showMultiple - newDiskon;
                        setBbelli((prevBelli) => ({
                            ...prevBelli,
                            [rowInd]: value * betDiscount.showMultiple,
                        }));
                        setBolakBalik((prevBolakBalik) => ({
                            ...prevBolakBalik,
                            [rowInd]: newBolakBalik,
                        }));
                    }
                }
            }
        }
    }, [belliBets, maxAmountValue])

    const validateBeliInput = (rowIndex, newBets) => {
        const inputValues = [
            newBets[`bets${rowIndex}1`] || "",
            newBets[`bets${rowIndex}2`] || "",
        ];

        const filterValue = inputValues.filter(item => item !== '' && item !== 'X').length
        if (filterValue === 2) {
            const newBeliDisabled = [...beliDisabled];
            newBeliDisabled[rowIndex] =
                setBeliDisabled(newBeliDisabled);
            if (newBeliDisabled[rowIndex] == true) {
                delete newBets[rowIndex];
                setBets(newBets);
                const newDiskon = { ...diskon };
                const newBolak = { ...bolakBalik };
                delete newDiskon[rowIndex];
                delete newBolak[rowIndex];
                setDiskon(newDiskon);
                setBolakBalik(newBolak);
            }
            const newIndex = `${rowIndex}-belli`;
            setTimeout(() => {
                colRef.current[newIndex].focus();
            }, 0)
        } else {
            setBeliDisabled((prev) => {
                const updated = [...prev];
                updated[rowIndex] = true; // Set the particular row to the desired value
                return updated;
            });

            setBelliBets({
                ...belliBets,
                [rowIndex]: '',
            });
        }
    };

    const handleInputChangeBelli = (e, rowIndex) => {
        setRowInd(rowIndex)
        let { name, value } = e.target;
        value = value.replace(',', '.');
        let regex = '';
        if (String(betDiscount.showMin2dTengah).length === 3) {
            regex = /^\d*([.,]\d?)?$/;
            value = dotNumberValidation(value);
        } else {
            regex = /^\d*$/;
            value = withDotValidation(value);
        }
        if (regex.test(value)) {
            setBelliBets({
                ...belliBets,
                [name]: value,
            });

            if (belli[rowIndex] && value == '') {
                const newBelli = { ...belli }
                delete newBelli[rowIndex];
                setBbelli(newBelli);
            }
            else {
                setBbelli({
                    ...belli,
                    [rowIndex]: value ? parseInt(value) * betDiscount.showMultiple : '',
                });
            }
        }
    };

    const fixDecimal = value => {
        if (Array.isArray(value)) {
            return value.map(item => fixDecimal(item));
        }
        return !isNaN(value) ? parseFloat(parseFloat(value).toFixed(1)) : value;
    };

    useEffect(() => {
        let rowBet;
        if (device === "Desktop") {
            rowBet = values[rowInd]
        }
        else {
            rowBet = mobbets["mobbets" + rowInd]
        }

        if (bolBalikRow.filter((item) => item !== undefined).length > 0) {
            let newTotalBetAmount = mobileTotalBetCalculate("2DTENGAH", rowBet, belliBets, rowInd, betDiscount, true, bolBalikRow, bolBalikRowALL, values, "discount", device)
            if (device === "Desktop") {
                setBBPayAmount(fixDecimal(newTotalBetAmount[0]))
                setTotalBetAmount(fixDecimal(newTotalBetAmount[2]))
                setDiskon(fixDecimal(newTotalBetAmount[1]))
            }
            else {
                setTotalBetAmount(fixDecimal(newTotalBetAmount))
            }
        }
        else {
            setBBPayAmount(0)
            let newTotalBetAmount = 0;
            const valBelli = Object.entries(belliBets).filter(
                ([key, value]) => value !== undefined && value !== ""
            );
            if (valBelli.length > 0) {
                newTotalBetAmount = totalBetAmount;
            }
            else {
                newTotalBetAmount = 0;
            }
            newTotalBetAmount = mobileTotalBetCalculate("2DTENGAH", rowBet, belliBets, rowInd, betDiscount, false, bolBalikRow, bolBalikRowALL, values, "discount", device)
            if (device === "Desktop" && newTotalBetAmount !== undefined) {
                setBBPayAmount(fixDecimal(newTotalBetAmount[0]))
                setTotalBetAmount(fixDecimal(newTotalBetAmount[1]))
                setDiskon(fixDecimal(newTotalBetAmount[2]))
            }
            else {
                setTotalBetAmount(fixDecimal(newTotalBetAmount))
            }
            // calculateDiscount()

        }
    }, [belliBets, values, bolBalikRow])

    const handleBelliChangeBlur = (e, rowIndex) => {
        let { name, value } = e.target;
        value = value.replace(',', '.');
        let regex = '';
        if (String(betDiscount.showMin3dDepan).length === 3) {
            regex = /^\d*([.,]\d?)?$/;
            value = dotNumberBlurValidation(value);
        } else {
            regex = /^\d*$/;
            value = withDotValidation(value);
        }

        updateBetNumber();
        let bet;
        if (device === "Desktop") {
            bet = bets['bets' + rowInd]
        }
        else {
            bet = mobbets['mobBets' + rowInd]
        }
        const isBelliValid = (belliBet) => {
            return belliBet !== "" && belliBet !== undefined
        }
        if (isBelliValid(belliBets[rowInd])) {
            if (belliBets[rowInd] * betDiscount.showMultiple > betDiscount.showMax2dTengah) {
                setBelliBets({
                    ...belliBets,
                    [rowInd]: ""
                })
            }
            else if (belliBets[rowInd] * betDiscount.showMultiple < betDiscount.showMin2dTengah) {
                setBelliBets({
                    ...belliBets,
                    [rowIndex]: "",
                });
            }
            else {
                // calculateDiscount()
            }
        }
        e.target.value = value;
        handleInputChangeBelli(e, rowIndex, "Belli");
    };

    const calculateDiscount = () => {
        let newDiskon = 0;

        const isBelliValid = (belliBet) => {
            return belliBet !== "" && belliBet !== undefined && !isNaN(belliBet)
        }

        let value = isBelliValid(belliBets[rowInd]) ? belliBets[rowInd] : 0;
        newDiskon = (value * betDiscount.showMultiple * betDiscount.showDisc2d) / 100;
        setDiskon({
            ...diskon,
            [rowInd]: newDiskon,
        });
    }

    useEffect(() => {
        setAngaka([]);
        setAngakaBB([]);
        let newAngaka = [];
        let newAngakaBB = [];
        const allBolakBalik = bolBalikRow.filter(item => item !== undefined)

        // Check if bolBalikRow has values
        if (allBolakBalik.length > 0) {
            newAngaka = [];
            newAngakaBB = [];
            const isValidElement = (belliBet) => {
                return belliBet !== "" && !Number.isNaN(belliBet) && belliBet !== null && belliBet !== undefined
            }

            values.forEach((val, index) => {
                let isChecked = false; // Initialize a flag to check if any item is checked

                bolBalikRow.forEach((item) => {
                    if (item === index && isValidElement(belliBets[index])) {
                        newAngakaBB.push([val, belliBets[item], 'success']);
                        isChecked = true; // Set the flag to true if the item is checked
                    }
                });

                if (!isChecked && val !== undefined && isValidElement(belliBets[index])) {
                    newAngaka.push([val, belliBets[index], 'success']);
                }
            });

            setAngakaBB(newAngakaBB);
            if (bolBalikRowALL > 0) {
                setMainButton(false)
            }

            // Check if all values are checked
            if (newAngakaBB.length === values.length) {
                setAngaka([]); // Set angaka to an empty array if all values are checked
            } else {
                setAngaka(newAngaka);
            }
        } else {
            // Handle the case when bolBalikRow is empty
            values.forEach((item, index) => {
                if (item !== undefined && belliBets[index] !== "" && !Number.isNaN(belliBets[index]) && belliBets[index] !== null && belliBets[index] !== undefined) {
                    newAngaka.push([item, belliBets[index] * betDiscount.showMultiple, 'success']);
                }
            });
            setAngaka(newAngaka);
        }

        if (payAmount > 0 && bolakBalikRespArray.length > 0) {
            setPayAmountStatus(true)
        }
    }, [values, bolBalikRow, belliBets]);

    function setAngakaArray() {
        if (angaka.length !== undefined) {
            if (angaka.length > 0) {
                const filteredAngaka = angaka.filter(item => item !== undefined && item[1] !== undefined);
                setReqData({
                    ...reqData,
                    gameId: gameId,
                    dataangka: filteredAngaka
                });
            }
            else {
                setReqData({
                    ...reqData,
                    gameId: gameId,
                    dataangka: []
                });
            }
        }
    }

    useEffect(() => {
        setAngakaArray();
    }, [angaka]);

    useEffect(() => {
        allDataReset();
    }, [gameId])

    useEffect(() => {
        let newAgkaArrays = [];
        bolakBalikRespArray.map((val) => {
            if (val.showNumber) {
                val.showNumber.map((value) => {
                    const newAgkaArray = [value, val.taruhan, 'success'];
                    newAgkaArrays.push(newAgkaArray);
                })
            }
        })
        setCheckedBoxes(Array(bolakBalikRespArray.length).fill(true));
        setBolakBalikRespAngka(newAgkaArrays);
        setReqBBData({
            ...reqBBData,
            gameId: gameId,
            dataangka: newAgkaArrays
        });
    }, [bolakBalikRespArray])

    useEffect(() => {
        setReqBBData({
            ...reqBBData,
            gameId: gameId,
            dataangka: bolakBalikRespAngka
        });
    }, [bolakBalikRespAngka])

    const handleCheckboxToggle = (index) => {
        const newCheckedBoxes = [...checkedBoxes];
        newCheckedBoxes[index] = !newCheckedBoxes[index];
        setCheckedBoxes(newCheckedBoxes);
    };

    let i = 0;
    const updateReqData = () => {
        let newAgkaArrays = [];
        let newAngakaData = [];
        let updateNeAngaka = [];

        if (bolakBalikRespArray.length > 0) {
            setBolakBalikRespAngka([]);
            setNewAngakaD([]);
        }

        let addPayAmount = 0;
        let addDiscountAmount = 0;
        bolakBalikRespArray.forEach((val, ind) => {
            if (checkedBoxes[ind] !== false) {
                if (val.showNumber) {
                    let newAgkaArr;
                    val.showNumber.forEach((value) => {
                        let newAgkaArray;
                        if (val.type === "2D Belakang") {
                            newAgkaArray = ["XX" + value, val.taruhan, 'success'];
                            newAgkaArr = "XX" + val.angka;
                        } else if (val.type === "2D Depan") {
                            newAgkaArray = [value + "XX", val.taruhan, 'success'];
                            newAgkaArr = val.angka + "XX";
                        } else if (val.type === "2D Tengah") {
                            newAgkaArray = ["X" + value + "X", val.taruhan, 'success'];
                            newAgkaArr = "X" + val.angka + "X";
                        } else if (val.type === "3D Belakang") {
                            newAgkaArray = ["X" + value, val.taruhan, 'success'];
                            newAgkaArr = "X" + val.angka;
                        } else if (val.type === "3D Depan") {
                            newAgkaArray = [value + "X", val.taruhan, 'success'];
                            newAgkaArr = val.angka + "X";
                        } else if (val.type === "4D") {
                            newAgkaArray = [value, val.taruhan, 'success'];
                            newAgkaArr = val.angka;
                        }
                        newAgkaArrays.push(newAgkaArray);
                    });
                    updateNeAngaka.push(newAgkaArr);
                }

                if (typeof val.showNumber != "undefined") {
                    let dicountV = (val.taruhan * val.showNumber.length / 100) * betDiscount.showDisc2d;
                    addDiscountAmount += dicountV
                    addPayAmount = addPayAmount + val.taruhan * val.showNumber.length - dicountV;
                }
                else {
                    let dicountV = (val.taruhan / 100) * betDiscount.showDisc2d;
                    addDiscountAmount += dicountV
                    addPayAmount = addPayAmount + val.taruhan - dicountV;
                }
            }
        });

        if (
            bolakBalikRespArray.length > 0 &&
            reqData.dataangka.length > 0
        ) {
            reqData.dataangka.map((value) => {
                if (value[0] !== undefined && !Number.isNaN(value[1])) {
                    if (device === "Desktop") {
                        newAngakaData.push([value[0] + 'XX', value[1] * betDiscount.showMultiple, 'success']);
                    }
                    else {
                        newAngakaData.push(['X' + value[0] + 'X', value[1] * betDiscount.showMultiple, 'success']);
                    }
                }
            })
            let newTotalAmount = 0
            if (discountAmount > 0 && payAmount > 0 && diskon[rowInd] !== undefined && bolakBalik[rowInd] !== undefined && i == 0 && payAmountStatus == true) {
                addDiscountAmount = discountAmount + diskon[rowInd]
                addPayAmount = payAmount + bolakBalik[rowInd];
                newTotalAmount = totalAmount + belliBets[rowInd] * betDiscount.showMultiple
                setTotalAmount(newTotalAmount);
                setPayAmountStatus(false);
                ++i
            }
        }

        setPayAmount(addPayAmount)
        setDiscountAmount(addDiscountAmount)
        setBolakBalikRespAngka(newAgkaArrays);
        setNewAngakaD(newAngakaData);
    };

    useEffect(() => {
        updateReqData();
    }, [checkedBoxes, reqData]);

    const hideCommonToaster = () => {
        const commonToaster = document.getElementById("commonToaster");
        if (commonToaster) {
            commonToaster.style.display = "none";
        }
    };

    const submitProcessOk = async () => {
        setShowConfirmationPopup(false)
        if (reqData.dataangka.length > 0 || reqBBData.dataangka.length > 0) {
            const processApiResponse = async (requestData) => {
                try {
                    const response = await makeAjax(url.TOGEL_API.process4D3D2D, requestData);
                    if (response.status !== respStatus['SUCCESS']) {
                        if (response.code === "sub_game_status_close") {
                            setShowGameClose(true);
                            showMessage(false);
                            hideCommonToaster();
                            dispatch(setCommonConfig({ key: "subGameOnOffStatus", value: 0 }));
                            return;
                        }
                        if (response.code === "market_close_err") {
                            setShowMarketClose(true);
                            showMessage(false);
                            hideCommonToaster();
                            dispatch(setCommonConfig({ key: "marketCloseStatus", value: 0 }));
                            return;
                        }
                        if (response.code !== "validation_error") {
                            response.code ? setErrorMessage(props.t(response.code))
                                : setErrorMessage(props.t("guess_bet_wrong_place"));
                            setShowErrorPopup(true);
                            return false;
                        }
                        showMessage("server error No data find", "error", "error");
                        return false;
                    }
                    setRespData(prevArray => [...prevArray, response.data]);
                    return true;
                } catch (error) {
                    showMessage("An error occurred while processing the request", "error", "error");
                    return false;
                }
            };

            let isSuccess = true;

            if (bolakBalikRespArray.length > 0 && bolBalikRow.filter(item => item !== undefined).length > 0) {
                if (reqBBData.dataangka.length > 0) {
                    isSuccess = await processApiResponse(reqBBData);
                }
                if (isSuccess && newReqData.dataangka.length > 0) {
                    isSuccess = await processApiResponse(newReqData);
                }
            } else {
                if (changeReqData.dataangka.length > 0) {
                    isSuccess = await processApiResponse(changeReqData);
                }
                else {
                    isSuccess = await processApiResponse(reqData);
                }
            }

            if (isSuccess) {
                setSuccessPopup(true);
                allDataReset();
            }
            dispatch(getUserBalance());
        }
        else {
            setErrorMessage(props.t('guess_bet_wrong'))
            setShowErrorPopup(true)
        }
    }

    const submitProcess = (event) => {
        const valLeng = values.filter(item => item !== undefined);
        const valBelli = Object.entries(belliBets).filter(([key, value]) => value !== undefined && value !== '');
        const total = Object.values(bolakBalik).reduce((total, item) => total + item, 0);
        if (totalAmount > user_balance.coin && bolakBalikRespArray.length > 0) {
            setErrorMessage(props.t('insufficiant_balance_err'));
            setShowErrorPopup(true);
        }
        else if (total > user_balance.coin && bolakBalikRespArray.length === 0) {
            setErrorMessage(props.t("insufficiant_balance_err"));
            setShowErrorPopup(true);
        }
        else {
            if (device === "Mobile") {
                if (reqBBData.dataangka.length === 0 && bolBalikRow.filter(item => item !== undefined).length === 0 && reqData.dataangka.length > 0) {
                    setChangesReqData(initialReq4D)
                }
            }
            if (values.length > 0 && Object.keys(belliBets).length > 0) {
                if (valLeng.length === valBelli.length) {
                    setSuccessMessage('');
                    setShowConfirmationPopup(true);
                } else {
                    setSuccessMessage("");
                    setShowConfirmationPopup(true);
                }
            } else {
                setErrorMessage(props.t('guess_bet_wrong'));
                setShowErrorPopup(true);
            }
        }
    };

    const handleDeafultInputBlur = (e) => {
        let value = e.target.value;
        value = value.replace(',', '.');
        let regex = '';
        if (String(betDiscount.showMin2dTengah).length === 3) {
            regex = /^\d*([.,]\d?)?$/;
            value = dotNumberBlurValidation(value);
        } else {
            regex = /^\d*$/;
            value = withDotValidation(value);
        }
        if (regex.test(value)) {
            setDefaultvalue(value);
        }
    };

    const handleDeafultInputChange = (e) => {
        let value = e.target.value;
        value = value.replace(',', '.');
        let regex = '';
        if (String(betDiscount.showMin2dTengah).length === 3) {
            regex = /^\d*([.,]\d?)?$/;
            value = dotNumberValidation(value);
        } else {
            regex = /^\d*$/;
            value = withDotValidation(value);
        }
        if (regex.test(value)) {
            setDefaultvalue(value);
        }
    };

    const handleRowsToShowChange = (e) => {
        setRowsToShow(parseInt(e.target.value, 10));
    };

    useEffect(() => {
        setBeliDisabled(prevBeliDisabled => {
            if (prevBeliDisabled !== false) {
                return [...prevBeliDisabled, ...Array(rowsToShow).fill(true)];
            } else {
                return prevBeliDisabled.slice(0, rowsToShow);
            }
        });
    }, [rowsToShow]);

    const rowDataReset = (rowIndex) => {
        const newBets = { ...bets };
        const newBelliBets = { ...belliBets };
        const newMobBets = { ...mobbets };
        const delValues = [...values];
        const delAngaka = [...angaka];
        const newBelli = { ...belli }
        const newDiskon = { ...diskon };
        const newBolak = { ...bolakBalik };
        const newBolakBalikRow = [...bolBalikRow];
        delete newBelliBets[rowIndex]; // or whichever key you want
        delete newBets['bets' + rowIndex + '' + 0]; // or whichever key you want
        delete newBets['bets' + rowIndex + '' + 1]; // or whichever key you want
        delete newBets['bets' + rowIndex + '' + 2]; // or whichever key you want
        delete newBets['bets' + rowIndex + '' + 3]; // or whichever key you want
        delete newMobBets['mobbets' + rowIndex]; // or whichever key you want
        delValues[rowIndex] = undefined;
        delete newBelli[rowIndex];
        delete newDiskon[rowIndex];
        delete newBolak[rowIndex];
        delete delAngaka.splice(rowIndex, 1);
        newBolakBalikRow[rowIndex] = undefined;
        setValues(delValues);
        setAngaka(delAngaka);
        setBets(newBets);
        setBelliBets(newBelliBets);
        setBbelli(newBelli);
        setDiskon(newDiskon);
        setBolakBalik(newBolak);
        setMobBets(newMobBets);
        setBolBalikRow(newBolakBalikRow);
        const newBeliDisabled = [...beliDisabled];
        newBeliDisabled[rowIndex] = true;
        setBeliDisabled(newBeliDisabled);
        // Reset the checkbox for the specific row index
        const checkbox = document.getElementById(`checkValue${rowIndex}`);
        if (checkbox) {
            checkbox.checked = false;
        }
    }

    const allDataReset = () => {
        setBets({});
        setBelliBets({})
        setMobBets({})
        setValues([]);
        setBbelli({});
        setDiskon({});
        setBolakBalik({});
        setReqData(initialReq4D)
        setNewReqData(initialReqBB)
        setReqBBData(initialReqBB4D);
        setNewAngakaD([])
        setBolakBalikRespArray([])
        setBolakBalikRespAngka([])
        setBolBalikRow([])
        setBolBalikRowAll(0)
        setDefaultvalue('')
        setBeliDisabled(Array(rowsToShow).fill(true));
        document.querySelectorAll('input[type="checkbox"]').forEach(checkbox => {
            checkbox.checked = false;
        });
        setProbabilityTable(false)
        setMainButton(true)
        setTotalAmount(0)
        setChangesReqData(initialReq4D)
        setTotalBetAmount([])
        setBBPayAmount(0)
    }

    //new/////
    const handleSelectAll = (e) => {
        const isChecked = e.target.checked;
        const updatedBeliDisabled = [...beliDisabled];
        const newBets = { ...bets };
        const newMobBets = { ...mobbets };
        const newValues = [...values];
        const newBelli = { ...belli };
        const newBelliBets = { ...belliBets };
        const newDiskon = { ...diskon };
        const newBolak = { ...bolakBalik };

        const updatedBolBalikRow = []

        document.querySelectorAll('input[type="checkbox"].chk_bb').forEach((checkbox, index) => {
            checkbox.checked = isChecked;
            if (isChecked) {
                setBolBalikRowAll(1)
                if (newValues[index] && newBelliBets[index] !== undefined) {
                    updatedBeliDisabled[index] = false;
                    updatedBolBalikRow.push(index);
                    // Ensure the state updates for selected items
                    newBets[`bets${index}0`] = newBets[`bets${index}0`] || ''; // Set any initial required state
                    newBets[`bets${index}1`] = newBets[`bets${index}1`] || '';
                    newBets[`bets${index}2`] = newBets[`bets${index}2`] || '';
                    newBets[`bets${index}3`] = newBets[`bets${index}3`] || '';
                    newMobBets[index] = newMobBets[index] || '';
                    newValues[index] = newValues[index] || '';
                    newBelli[index] = newBelli[index] || '';
                    newBelliBets[index] = newBelliBets[index] || '';
                    newDiskon[index] = newDiskon[index] || '';
                    newBolak[index] = newBolak[index] || '';
                }
                else {
                    updatedBolBalikRow.push(index);
                    // updatedBeliDisabled[index] = true;
                    // setBolBalikRow((prev) => prev.filter((i) => i !== index));
                }
            } else {
                setBolBalikRowAll(0)
            }
        });

        if (!isChecked) {
            setBolBalikRow([]); // Clear bolBalikRow if not checked
        } else {
            setBolBalikRow(updatedBolBalikRow); // Set bolBalikRow with updated indexes
        }

        setBets(newBets);
        setMobBets(newMobBets);
        setValues(newValues);
        setBbelli(newBelli);
        setBelliBets(newBelliBets)
        setDiskon(newDiskon);
        setBolakBalik(newBolak);
        setBeliDisabled(updatedBeliDisabled);
        setMainButton(!isChecked); // Enable or disable the main button based on the state
    };

    // Ensure checkInputHandler function also updates bolBalikRow accordingly
    const checkInputHandler = (e, rowIndex, columnName) => {
        let checkVal = document.getElementById('checkValue' + rowIndex);
        let newBolakBalikRow = [...bolBalikRow];
        if (checkVal.checked) {
            setMainButton(false)
            values.forEach((_, ind) => {
                if (newBolakBalikRow[ind] === undefined) {
                    newBolakBalikRow[ind] = undefined;
                }
            });
            newBolakBalikRow[rowIndex] = rowIndex;
            setBolBalikRow(newBolakBalikRow);
        } else {
            setMainButton(true);
            if (bolBalikRowALL > 0) {
                newBolakBalikRow[rowIndex] = undefined;
                setBolBalikRow(newBolakBalikRow);
            }
            else {
                // setBolBalikRow((prev) => prev.filter((row) => row !== rowIndex));
                newBolakBalikRow[rowIndex] = undefined;
                setBolBalikRow(newBolakBalikRow);
            }
        }
        let rowBet;
        if (device === "Desktop") {
            rowBet = values[rowInd]
        }
        else {
            rowBet = mobbets["mobbets" + rowInd]
        }
        if (newBolakBalikRow.filter((item) => item !== undefined).length > 0) {
            const updateAmount = mobileTotalBetCalculate("2DTENGAH", rowBet, belliBets, rowIndex, betDiscount, true, newBolakBalikRow, bolBalikRowALL, values, "fullBet", device)
            if (device === "Desktop") {
                setBBPayAmount(fixDecimal(updateAmount[0]))
                setTotalBetAmount(fixDecimal(updateAmount[2]))
                setDiskon(fixDecimal(updateAmount[1]))
            }
            else {
                setTotalBetAmount(fixDecimal(updateAmount))
            }
        }
        else {
            setBBPayAmount(0)
        }
    };

    useEffect(() => {
        setNewReqData({
            ...newReqData,
            gameId: gameId,
            dataangka: newAngakaD
        })
    }, [newAngakaD])

    const submitProcessBB = (e) => {
        setProbabilityTable(false)
        setBolakBalikRespArray([]);
        setTotalAmount(0);
        let index = 1;
        if (angakaBB.length > 0) {
            if ((Object.keys(belliBets)).length > 0) {
                values.map((val, ind) => {
                    if (val !== undefined && belliBets[ind] !== "" && belliBets[ind] !== undefined && !Number.isNaN(belliBets[ind]) && belliBets[ind] !== null) {
                        if (ind === bolBalikRow[ind] && bolBalikRow[ind] !== undefined) {
                            const action = "generate";
                            const reqBBData = {
                                action: action,
                                gameId: gameId,
                                gameType: "bolak-balik",
                                betTogelAuth: "betTogelAuth",
                                allowPartner: null,
                                checklistid: ++index,
                                dataangka: [val, belliBets[ind], "success"],
                                mobBets: (device === "Desktop") ? 0 : 2,
                                multiple: multipleValue,
                            }
                            bolakBalikSubmit(reqBBData);
                        }
                        else {
                            const action = "generate4d3d2d";
                            const reqBBData = {
                                action: action,
                                gameId: gameId,
                                gameType: "bolak-balik",
                                betTogelAuth: "betTogelAuth",
                                allowPartner: null,
                                checklistid: index + ind,
                                dataangka: [val, belliBets[ind], "success"],
                                mobBets: (device === "Desktop") ? 0 : 2,
                                multiple: multipleValue,
                            }
                            bolakBalikSubmit(reqBBData);
                        }
                    }
                })
                setMainButton(true);
            } else {
                setErrorMessage(props.t('guess_bet_wrong'))
                setShowErrorPopup(true)
            }
        } else {
            if (values.length > 0) {
                if (angaka.length > 0) {
                    let newDataAngaka = []
                    angaka.map((item, ind) => {
                        newDataAngaka.push([item[0], item[1] * betDiscount.showMultiple, item[2]]);
                    })
                    setChangesReqData({
                        ...changeReqData,
                        gameId: gameId,
                        dataangka: newDataAngaka
                    })
                }
                else {
                    setErrorMessage(props.t("guess_bet_wrong"));
                    setShowErrorPopup(true);
                }
            }
            else {
                document.querySelectorAll('input[type="checkbox"]').forEach(checkbox => {
                    checkbox.checked = false;
                });
                setBolBalikRow([]);
                setMainButton(true);
                setBolBalikRowAll(0)
            }
        }
    };

    useEffect(() => {
        if (changeReqData.dataangka.length > 0) {
            submitProcess()
        }
    }, [changeReqData])

    const bolakBalikSubmit = (bbData) => {
        makeAjax(
            url.TOGEL_API.processBolakBalik, bbData).then(response => {
                if (response.status !== respStatus['SUCCESS']) {
                    if (response.code !== "validation_error") {
                        if (response.code == "market_close_err" || response.code === "sub_game_status_close") {
                            setShowGameClose(true);
                            showMessage(false);
                            hideCommonToaster();
                            dispatch(setCommonConfig({ key: "subGameOnOffStatus", value: 0 }));
                            return;
                        }
                        response.code ? showMessage(props.t(response.code), "error", "error")
                            : showMessage(props.t('guess_bet_wrong_place'), "error", "error")
                        return;
                    }
                    showMessage("server error No data find", "error", "error");
                    return;
                }
                setBolakBalikRespArray(prevArray => [...prevArray, response.data]);
                setTotalAmount(prevTotal => {
                    const newTotal = prevTotal + (response.data.taruhan * (typeof response.data.showNumber != 'undefined' ? response.data.showNumber.length : 1));
                    return newTotal;
                });
                setProbabilityTable(true)
                setMainButton(true)
            });
    }

    const handlePopupClose = () => {
        setRespData([])
        setSuccessPopup(false);
        setProbabilityTable(false)
        allDataReset()
        setTotalAmount(0)
        setBBPayAmount(0)
        setTotalBetAmount([])
    }
    const hanldeConfirmationPopupClose = () => {
        setShowConfirmationPopup(false);
        setShowCancelledPopup(true)
    }
    useEffect(() => {
        if (device === "Mobile" && probabilityTable) {
            totaldiv.current.scrollIntoView({
                behavior: "smooth",
                block: "start",
            });
        }
    }, [bolakBalikRespArray, device])
    return (
        <>
            {showGameClose ? (
                <GameClosedPopup />
            ) : showMarketClose ? (
                <MarketClose />
            ) : (
                <>
                    <div className="container" style={{ flexDirection: "column" }}>
                        <CommonBetHeader rowsToShow={rowsToShow} handleRowsToShowChange={handleRowsToShowChange} bbPayAmount={bbPayAmount} totalBetAmount={totalBetAmount} />
                        <table className="bet-diskon-table">
                            <thead>
                                <tr>
                                    <th>{props.t("no.")}</th>
                                    <th>{props.t("number")}</th>
                                    <th>
                                        {/* <label htmlFor="belliInput">{props.t("buy")}</label> */}
                                        <input
                                            id="inputs"
                                            type="text"
                                            autoComplete="off"
                                            placeholder="Auto Bet"
                                            value={defaultValue}
                                            onChange={handleDeafultInputChange}
                                            onBlur={handleDeafultInputBlur}
                                            inputMode="decimal"
                                            pattern="[0-9]*[.,]?[0-9]**"
                                        />
                                    </th>
                                    {device === "Desktop" && (
                                        <>
                                            <th>{props.t("discount")}</th>
                                            <th>{props.t("pay")}</th>
                                        </>
                                    )}
                                    <th className="check_column">
                                        <div>
                                            {props.t("BB")}
                                            <input
                                                type="checkbox"
                                                onClick={(e) => handleSelectAll(e)}
                                            />
                                        </div>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {[...Array(rowsToShow)].map((_, index) => (
                                    <tr
                                        key={index}
                                        className={index % 2 === 0 ? "even-row" : "odd-row"}
                                    >
                                        <td>{index + 1}</td>
                                        {device === "Desktop" ? (
                                            <td className="number-inputs">
                                                {[...Array(inputToShow)].map((_, keyInp) => (
                                                    <input
                                                        key={"betInput" + index + "" + keyInp}
                                                        autoComplete="off"
                                                        type="text"
                                                        maxlength="1"
                                                        className={`betInput${index}${keyInp}`}
                                                        ref={(el) =>
                                                            (colRef.current[`${index}${keyInp}`] = el)
                                                        }
                                                        name={`bets${index}${keyInp}`}
                                                        value={(keyInp == 0 || keyInp == 3) ? "X" :
                                                            bets["bets" + index + "" + keyInp]
                                                                ? bets["bets" + index + "" + keyInp]
                                                                : ""
                                                        }
                                                        disabled={(keyInp == 0 || keyInp == 3) ?? true}
                                                        onChange={(e) =>
                                                            handleInputChange(e, index, keyInp, "Tebak")
                                                        }
                                                        onBlur={(e) =>
                                                            handleInputFocus(e, index, keyInp, "blur")
                                                        }
                                                    />
                                                ))}
                                            </td>
                                        ) : (
                                            <td className="inputs">
                                                <input
                                                    type="text"
                                                    maxlength="3"
                                                    name={`mobbets${index}`}
                                                    value={
                                                        mobbets["mobbets" + index]
                                                            ? mobbets["mobbets" + index]
                                                            : ""
                                                    }
                                                    onChange={(e) => handleInputChange(e, index, "Tebak")}
                                                    autocomplete="off"
                                                    inputMode="numeric"
                                                    pattern="[0-9]*"
                                                />
                                            </td>
                                        )}
                                        <td className="inputs">
                                            <input
                                                type="text"
                                                // placeholder={beliDisabled[index] == true ? "Bet" : ""}
                                                placeholder="Bet"
                                                name={`${index}`}
                                                value={belliBets[index] ? belliBets[index] : ""}
                                                ref={(el) => (colRef.current[`${index}-belli`] = el)}
                                                onChange={(e) =>
                                                    handleInputChangeBelli(e, index, "Belli")
                                                }
                                                onFocus={(e) => handleFocusInput(e, index)}
                                                disabled={beliDisabled[index]}
                                                onBlur={(e) => handleBelliChangeBlur(e, index)}
                                                autocomplete="off"
                                                inputMode="decimal"
                                                pattern="[0-9]*[.,]?[0-9]**"
                                            />
                                        </td>
                                        {device === "Desktop" && (
                                            <>
                                                <td className="inputs">
                                                    <input
                                                        name={index}
                                                        readOnly
                                                        tabindex="-1"
                                                        type="text"
                                                        value={diskon[index] ? formatPrice(diskon[index]) : ""}
                                                    />
                                                </td>
                                                <td className="inputs">
                                                    <input
                                                        name={index}
                                                        readOnly
                                                        tabindex="-1"
                                                        type="text"
                                                        value={
                                                            totalBetAmount[index]
                                                                ? formatPrice(totalBetAmount[index])
                                                                : ""
                                                        }
                                                    />
                                                </td>
                                            </>
                                        )}
                                        <td>
                                            <input
                                                tabindex="-1"
                                                type="checkbox"
                                                id={`checkValue${index}`}
                                                onClick={(e) => checkInputHandler(e, index, "")}
                                                className="chk_bb"
                                            />
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                    {probabilityTable && (
                        <div className="fourDThreeDTwoD_probability_container">
                            <div className="probability_container">
                                <table>
                                    <thead>
                                        <tr className="Heading">
                                            <th>{props.t("no.")}</th>
                                            <th></th>
                                            <th>{props.t("guess")}</th>
                                            <th>{props.t("Tipe")}</th>
                                            <th>{props.t("buy")}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {bolakBalikRespArray.length == 0 ? (
                                            <tr className="table_data_empty_row">
                                                <td colSpan="11">{"data_not_found"}</td>
                                            </tr>
                                        ) : (
                                            bolakBalikRespArray.map((value, index) => (
                                                <tr
                                                    key={index}
                                                    className={index % 2 === 0 ? "even-row" : "odd-row"}
                                                >
                                                    <td>{index + 1}</td>
                                                    <td align="center">
                                                        <input
                                                            type="checkbox"
                                                            className="chk_bb"
                                                            checked={checkedBoxes[index]}
                                                            defaultChecked
                                                            onChange={() => handleCheckboxToggle(index)}
                                                        />
                                                        <span
                                                            style={{ textAlign: "center", display: "block" }}
                                                        >
                                                            {value.count}
                                                        </span>
                                                    </td>
                                                    <td
                                                        className="bet_probability_column"
                                                        style={{
                                                            textAlign: "center",
                                                            display: "block",
                                                            wordBreak: "break-word",
                                                        }}
                                                    >
                                                        {value.showNumber
                                                            ? value.showNumber.toString().replace(/,/g, " : ")
                                                            : value.angka}
                                                    </td>
                                                    <td>{value.type}</td>
                                                    <td>
                                                        <span>
                                                            {formatPrice(value.taruhan)} X{" "}
                                                            {formatPrice(
                                                                typeof value.showNumber != "undefined"
                                                                    ? value.showNumber.length
                                                                    : 1
                                                            )}{" "}
                                                            ={" "}
                                                        </span>
                                                        {formatPrice(
                                                            parseInt(
                                                                typeof value.showNumber != "undefined"
                                                                    ? value.showNumber.length
                                                                    : 1
                                                            ) * parseInt(value.taruhan)
                                                        )}
                                                    </td>
                                                </tr>
                                            ))
                                        )}
                                    </tbody>
                                </table>
                            </div>
                            <div className="betdiskon_total">
                                <div className="d-flex flex-direction-column total">
                                    <div className="data-submit">
                                        {props.t("total_amount")}:
                                        <span className="betdiskon_total_amount">
                                            {formatPrice(totalAmount)}
                                        </span>
                                    </div>
                                    <div className="data-discount">
                                        {props.t("discount")}:
                                        <span className="betdiskon_total_discount">
                                            -{formatPrice(discountAmount)}
                                        </span>
                                    </div>
                                    <div className="total_pay">
                                        {props.t("total")} {props.t("pay")}:
                                        <span className="betdiskon_total_pay">
                                            {formatPrice(payAmount)}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}

                    <div className="last_div" ref={totaldiv}>
                        <div className="left_div">
                            <p>{props.t("guess_exact_number_2d_tengah")}</p>
                        </div>
                        <div className="right_div">
                            <ul className="button-list">
                                <li>
                                    <button onClick={allDataReset} className="reset">
                                        Reset
                                    </button>
                                </li>
                                {mainButton ? (
                                    <li>
                                        <button onClick={submitProcess} className="submit">
                                            {props.t("submit")}
                                        </button>
                                    </li>
                                ) : (
                                    <li>
                                        <button onClick={submitProcessBB} className="submit">
                                            {props.t("submit")}
                                        </button>
                                    </li>
                                )}
                            </ul>
                        </div>
                    </div>
                </>
            )}

            {showConfirmationPopup && (
                <ConfirmBetDeskonPopup
                    onClose={hanldeConfirmationPopupClose}
                    message={succMessage}
                    submitProcessOk={submitProcessOk}
                />
            )}
            {showCancelledPopup && (
                <CancelledBetDeskonPopup onClose={() => setShowCancelledPopup(false)} />
            )}
            {showConfirmationDataPopup && (
                <ConfirmDataBetDeskonPopup
                    onClose={() => setShowConfirmationDataPopup(false)}
                    message={succMessage}
                    submitProcessOk={submitProcessOk}
                />
            )}
            {successPopup && (
                <div className="popup-overlay ">
                    <BetSuccessPopup response={respData} onClose={handlePopupClose} />
                </div>
            )}
            {
                /*---error popup --*/
                showErrorPopup && (
                    <ErrorInnerPopup
                        modalTitle={""}
                        modalHeader={true}
                        onCloseModal={() => setShowErrorPopup(false)}
                    >
                        <ErrorPopup
                            message={errMessage}
                            onClose={() => setShowErrorPopup(false)}
                        />
                    </ErrorInnerPopup>
                )
            }
        </>
    );
};

export default withTranslation()(Bet_Diskon);